module.exports = __webpack_public_path__ + "static/media/check-on-paper.f18e81f6.svg";